module.exports = __webpack_public_path__ + "static/media/DigiNanny for Disabilities.63f098fd.png";